import { render, staticRenderFns } from "./multiChoice.vue?vue&type=template&id=2c06fbbf&scoped=true&"
import script from "./multiChoice.vue?vue&type=script&lang=js&"
export * from "./multiChoice.vue?vue&type=script&lang=js&"
import style0 from "./multiChoice.vue?vue&type=style&index=0&lang=css&"
import style1 from "./multiChoice.vue?vue&type=style&index=1&id=2c06fbbf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c06fbbf",
  null
  
)

export default component.exports